import { BaseRestResource } from "../../../../infrastructure/BaseRestResource";
import httpResource from "../../../core/infrastructure/httpResource";

class ThemeResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'mobile_assets/themes/v2');
    }
}

const themeResource = new ThemeResource();

export default themeResource;